module.exports = __webpack_public_path__ + "img/6-1.8db75514.jpg";